import { cn } from "@/lib/utils"

// The FullCast wordmark. Text-based for now — swap for a logo asset later.
export function Wordmark({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "font-display text-lg font-semibold tracking-tight text-ink-display",
        className,
      )}
    >
      Full<span className="text-accent-display">Cast</span>
    </span>
  )
}
